import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output, inject } from '@angular/core';
import { MemberProfile, ProfileCommand, ProfileEditor, ProfileOperation, EDITOR_TITLES } from '../domain/member-profile';
import { EmailEditorComponent } from './email-editor.component';
import { LoginIdEditorComponent } from './login-id-editor.component';
import { PasswordEditorComponent } from './password-editor.component';
import { EmergencyContactEditorComponent } from './emergency-contact-editor.component';

@Component({
  selector: 'app-profile-editor-dialog',
  imports: [EmailEditorComponent, LoginIdEditorComponent, PasswordEditorComponent, EmergencyContactEditorComponent],
  templateUrl: './profile-editor-dialog.component.html',
})
export class ProfileEditorDialogComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) kind!: ProfileEditor;
  @Input({ required: true }) member!: Readonly<MemberProfile>;
  @Input({ required: true }) operation!: ProfileOperation;
  @Input() busy = false;
  @Input() blocked = false;
  @Input() returnFocus: HTMLElement | null = null;
  @Output() submitted = new EventEmitter<ProfileCommand>();
  @Output() closed = new EventEmitter<void>();
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private bodyWasOpen = false;
  readonly titles = EDITOR_TITLES;
  get id(): string { return { email: 'updateEmailModal', loginId: 'updateLoginIdModal', password: 'changePasswordModal', emergency: 'updateEmModal' }[this.kind]; }
  private focusable(): HTMLElement[] {
    return Array.from(this.element.nativeElement.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]'))
      .filter(e => e.getClientRects().length > 0);
  }
  ngAfterViewInit(): void {
    this.bodyWasOpen = document.body.classList.contains('modal-open');
    document.body.classList.add('modal-open');
    this.element.nativeElement.querySelector<HTMLElement>('input')?.focus();
  }
  close(): void { if (!this.busy) this.closed.emit(); }
  backdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) this.close();
  }
  @HostListener('document:keydown', ['$event']) keydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') { event.preventDefault(); this.close(); }
    if (event.key !== 'Tab') return;
    const elements = this.focusable(), first = elements[0], last = elements[elements.length - 1];
    if (!first) { event.preventDefault(); this.element.nativeElement.querySelector<HTMLElement>('[role="dialog"]')?.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || !this.element.nativeElement.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !this.element.nativeElement.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  }
  ngOnDestroy(): void {
    if (!this.bodyWasOpen) document.body.classList.remove('modal-open');
    if (this.returnFocus?.isConnected) this.returnFocus.focus();
  }
}
